<template>
	<!-- 页面内容的上半部分 -->
	<div class="upList">
		<div v-for="(items, indexs) in tableData" :key="indexs" class="list-item"
			:style="{ width: itemWidthFunction(items.text) }">
			<div v-for="(item, index) in items.children" :key="index" class="item">
				<a :href="getAlink(item.url, item.uid, item)" @click="gotoLink(item)"
					:class="getcDeepBlueClass(item.uid)" :style="{ width: upListWidthFunction(item.text) }">{{ item.text
					}}
					<!-- <img
							v-if="item.shownew == true"
							src="../../../assets/special/listnews.png"
							alt=""
						/>
						<span
							v-else
							style="
								display: inline-block;
								width: 12px;
								height: 1px;
							"
						></span> -->
				</a>
			</div>
		</div>
	</div>
</template>
<script>
import { getNav } from '../../../api/home';
export default {
	name: 'upList',
	components: {},
	mixins: [],
	props: {},
	data() {
		return {
			tableData: [
				{
					"uid": "A70520",
					"relativetypeid": "NoRelative",
					"text": "创新",
					"apptext": null,
					"children": [
						{
							"uid": "A7052044",
							"relativetypeid": "Channel",
							"text": "中国式现代化",
							"apptext": null,
							"children": [
								{
									"uid": "A705204401",
									"relativetypeid": "Leaf",
									"text": "高层论述",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29166",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204402",
									"relativetypeid": "Leaf",
									"text": "权威视点",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29167",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204403",
									"relativetypeid": "Leaf",
									"text": "动态实践",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29168",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204404",
									"relativetypeid": "Leaf",
									"text": "理论研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29169",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204405",
									"relativetypeid": "Leaf",
									"text": "政策规划",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29170",
									"chnIds": "7321",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204406",
									"relativetypeid": "Channel",
									"text": "精选内容",
									"apptext": null,
									"children": [
										{
											"uid": "A70520440601",
											"relativetypeid": "Leaf",
											"text": "现代化经济体系",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 10,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29171",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440602",
											"relativetypeid": "Leaf",
											"text": "产业现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 20,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29172",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440603",
											"relativetypeid": "Leaf",
											"text": "农业农村现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 30,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29173",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440609",
											"relativetypeid": "Leaf",
											"text": "人口现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 31,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29221",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440604",
											"relativetypeid": "Leaf",
											"text": "教育现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 40,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29174",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440608",
											"relativetypeid": "Leaf",
											"text": "科技现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 50,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29205",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440605",
											"relativetypeid": "Leaf",
											"text": "国家治理现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 60,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29175",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440606",
											"relativetypeid": "Leaf",
											"text": "城市现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 70,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29176",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										},
										{
											"uid": "A70520440607",
											"relativetypeid": "Leaf",
											"text": "生态现代化",
											"apptext": null,
											"children": [],
											"orderStatus": null,
											"webchanneltypeid": 1,
											"introduction": null,
											"ordernumber": 80,
											"isnav": true,
											"url": "/list",
											"shownew": null,
											"email": null,
											"listType": 1,
											"level": 6,
											"tagIds": null,
											"tags": null,
											"location": null,
											"leafIds": "29177",
											"chnIds": "",
											"isleaf": true,
											"locations": null,
											"frequency": null,
											"products": null,
											"hotWords": null
										}
									],
									"orderStatus": null,
									"webchanneltypeid": 20,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 0,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "",
									"chnIds": "7322",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 1,
							"isnav": true,
							"url": "/list",
							"shownew": true,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "29166,29167,29168,29169,29170,29171,29172,29173,29174,29175,29176,29177,29205,29221",
							"chnIds": "7321",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052001",
							"relativetypeid": "Leaf",
							"text": "高质量发展",
							"apptext": null,
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 2,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30238",
							"chnIds": "",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052033",
							"relativetypeid": "channel",
							"text": "创新驱动",
							"apptext": "创新发展",
							"children": [
								{
									"uid": "A705203301",
									"relativetypeid": "Leaf",
									"text": "中央精神",
									"apptext": "中央精神",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23055",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								},
								{
									"uid": "A705203302",
									"relativetypeid": "Leaf",
									"text": "各地举措",
									"apptext": "各地举措",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23056",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								},
								{
									"uid": "A705203303",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": "动态视点",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23057",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								},
								{
									"uid": "A705203304",
									"relativetypeid": "Leaf",
									"text": "理论探讨",
									"apptext": "理论探讨",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "chenlu@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "23058",
									"chnIds": "5825",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": "2192",
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 3,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": "chenlu@drcnet.com.cn",
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "5825",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": "2192",
							"hotWords": null
						},
						{
							"uid": "A7052046",
							"relativetypeid": "Channel",
							"text": "新质生产力",
							"apptext": null,
							"children": [
								{
									"uid": "A705204601",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29695",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204602",
									"relativetypeid": "Leaf",
									"text": "专家探析",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29696",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204603",
									"relativetypeid": "Leaf",
									"text": "地方实践",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29697",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204604",
									"relativetypeid": "Leaf",
									"text": "深度研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29698",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204605",
									"relativetypeid": "Leaf",
									"text": "政策参考",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29699",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705204606",
									"relativetypeid": "Leaf",
									"text": "国际视角",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29724",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 4,
							"isnav": true,
							"url": "/list",
							"shownew": true,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7482",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},

						{
							"uid": "A7052004",
							"relativetypeid": "Channel",
							"text": "数字经济",
							"apptext": null,
							"children": [
								{
									"uid": "A705200401",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29145",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705200402",
									"relativetypeid": "Leaf",
									"text": "理论探讨",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 3,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29146",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705200403",
									"relativetypeid": "Leaf",
									"text": "实践案例",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 4,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29273",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 6,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7692",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 1,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70521",
					"relativetypeid": "NoRelative",
					"text": "协调",
					"apptext": null,
					"children": [
						{
							"uid": "A7052105",
							"relativetypeid": "Channel",
							"text": "区域协同发展",
							"apptext": null,
							"children": [
								{
									"uid": "A705210501",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30241",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705210502",
									"relativetypeid": "Leaf",
									"text": "权威视点",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 2,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30242",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705210503",
									"relativetypeid": "Leaf",
									"text": "深度分析",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 3,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30243",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 21,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7693",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052116",
							"relativetypeid": "Channel",
							"text": "粤港澳大湾区",
							"apptext": "地方产业集群",
							"children": [
								{
									"uid": "A705211601",
									"relativetypeid": "Leaf",
									"text": "建设进展",
									"apptext": "地方动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 30,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "hujie.li@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": "",
									"tags": null,
									"location": null,
									"leafIds": "24986",
									"chnIds": "6293",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": "2005,2053",
									"hotWords": null
								},
								{
									"uid": "A705211602",
									"relativetypeid": "Leaf",
									"text": "权威视角",
									"apptext": "地方动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 30,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "hujie.li@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": "",
									"tags": null,
									"location": null,
									"leafIds": "24987",
									"chnIds": "6293",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": "2005,2053",
									"hotWords": null
								},
								{
									"uid": "A705211603",
									"relativetypeid": "Leaf",
									"text": "深度分析",
									"apptext": "地方动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 30,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": "hujie.li@drcnet.com.cn",
									"listType": 1,
									"level": 5,
									"tagIds": "",
									"tags": null,
									"location": null,
									"leafIds": "24988",
									"chnIds": "6293",
									"isleaf": false,
									"locations": null,
									"frequency": null,
									"products": "2005,2053",
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 28,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": "hujie.li@drcnet.com.cn",
							"listType": 0,
							"level": 4,
							"tagIds": "",
							"tags": null,
							"location": null,
							"leafIds": "24986,24987,24988",
							"chnIds": "6293",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052197",
							"relativetypeid": "Leaf",
							"text": "海洋经济",
							"apptext": "海洋经济",
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 30,
							"introduction": null,
							"ordernumber": 35,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": "hujie.li@drcnet.com.cn",
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30272",
							"chnIds": "",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": "53",
							"hotWords": null
						}
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 2,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70522",
					"relativetypeid": "NoRelative",
					"text": "绿色",
					"apptext": null,
					"children": [
						{
							"uid": "A7052203",
							"relativetypeid": "Leaf",
							"text": "生态文明",
							"apptext": null,
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 41,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30240",
							"chnIds": "",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						
						{
							"uid": "A7052207",
							"relativetypeid": "Channel",
							"text": "绿色发展",
							"apptext": "节能环保产业",
							"children": [
								{
									"uid": "A705220701",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": "最新动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18527",
									"chnIds": "4799",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705220702",
									"relativetypeid": "Leaf",
									"text": "研究报告",
									"apptext": "研究报告",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18528",
									"chnIds": "4799",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705220703",
									"relativetypeid": "Leaf",
									"text": "政策法规",
									"apptext": "政策法规",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18529",
									"chnIds": "4799",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 43,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": "27",
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "4799",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052211",
							"relativetypeid": "Channel",
							"text": "新能源产业",
							"apptext": "新能源产业",
							"children": [
								{
									"uid": "A705221101",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": "最新动态",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18540",
									"chnIds": "4803",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705221102",
									"relativetypeid": "Leaf",
									"text": "研究报告",
									"apptext": "研究报告",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18541",
									"chnIds": "4803",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705221103",
									"relativetypeid": "Leaf",
									"text": "政策法规",
									"apptext": "政策法规",
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 50,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": "27",
									"tags": null,
									"location": null,
									"leafIds": "18542",
									"chnIds": "4803",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 45,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": "27",
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "4803",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						}
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 3,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70523",
					"relativetypeid": "NoRelative",
					"text": "开放",
					"apptext": null,
					"children": [
						{
							"uid": "A7052309",
							"relativetypeid": "Leaf",
							"text": "对外开放",
							"apptext": null,
							"children": [
								{
									"uid": "A705230901",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "22240,22241",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705230902",
									"relativetypeid": "Leaf",
									"text": "运行数据",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 2,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30250",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705230903",
									"relativetypeid": "Leaf",
									"text": "分析研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 3,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "22242,22243",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 51,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "22240,22241,30250,22242,22243",
							"chnIds": "",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 4,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				},
				{
					"uid": "A70524",
					"relativetypeid": "NoRelative",
					"text": "共享",
					"apptext": null,
					"children": [
						{
							"uid": "A7052443",
							"relativetypeid": "Channel",
							"text": "共同富裕",
							"apptext": null,
							"children": [
								{
									"uid": "A705244301",
									"relativetypeid": "Leaf",
									"text": "前沿进展",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29162",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705244302",
									"relativetypeid": "Leaf",
									"text": "专家观点",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29163",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705244303",
									"relativetypeid": "Leaf",
									"text": "理论研究",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29164",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705244304",
									"relativetypeid": "Leaf",
									"text": "政策参考",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 0,
									"isnav": true,
									"url": "/list",
									"shownew": null,
									"email": null,
									"listType": 1,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "29165",
									"chnIds": "7320",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 61,
							"isnav": true,
							"url": "/list",
							"shownew": true,
							"email": null,
							"listType": 0,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7320",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052401",
							"relativetypeid": "Leaf",
							"text": "中华民族共同体",
							"apptext": null,
							"children": [],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 64,
							"isnav": true,
							"url": "/list",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "30325",
							"chnIds": "7691",
							"isleaf": true,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						},
						{
							"uid": "A7052410",
							"relativetypeid": "Channel",
							"text": "优秀传统文化",
							"apptext": null,
							"children": [
								{
									"uid": "A705241001",
									"relativetypeid": "Leaf",
									"text": "前沿动态",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 1,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30252",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								},
								{
									"uid": "A705241002",
									"relativetypeid": "Leaf",
									"text": "深度分析",
									"apptext": null,
									"children": [],
									"orderStatus": null,
									"webchanneltypeid": 1,
									"introduction": null,
									"ordernumber": 2,
									"isnav": true,
									"url": "",
									"shownew": null,
									"email": null,
									"listType": null,
									"level": 5,
									"tagIds": null,
									"tags": null,
									"location": null,
									"leafIds": "30253",
									"chnIds": "",
									"isleaf": true,
									"locations": null,
									"frequency": null,
									"products": null,
									"hotWords": null
								}
							],
							"orderStatus": null,
							"webchanneltypeid": 1,
							"introduction": null,
							"ordernumber": 67,
							"isnav": true,
							"url": "",
							"shownew": null,
							"email": null,
							"listType": null,
							"level": 4,
							"tagIds": null,
							"tags": null,
							"location": null,
							"leafIds": "",
							"chnIds": "7698",
							"isleaf": false,
							"locations": null,
							"frequency": null,
							"products": null,
							"hotWords": null
						}
					],
					"orderStatus": null,
					"webchanneltypeid": 1,
					"introduction": null,
					"ordernumber": 5,
					"isnav": true,
					"url": "",
					"shownew": null,
					"email": null,
					"listType": null,
					"level": 3,
					"tagIds": null,
					"tags": null,
					"location": null,
					"leafIds": "",
					"chnIds": "",
					"isleaf": false,
					"locations": null,
					"frequency": null,
					"products": null,
					"hotWords": null
				}
			],
			//外层的宽度
			itemWidth: [
				// { name: '创新', width: '242px' },
				{ name: '创新', width: '386px' },
				// { name: '协调', width: '582px' },
				{ name: '协调', width: '261px' },
				{ name: '绿色', width: '221px' },
				// { name: '开放', width: '72px' },
				{ name: '开放', width: '71px' },
				{ name: '共享', width: '268px' },
			],
			//宽度+paddingleft
			// upListWidth: [
			// 	//创新
			// 	{ name: '中国式现代化', width: '94px' },
			// 	{ name: '高质量发展', width: '80px' },
			// 	{ name: '创新驱动', width: '66px' },
			// 	{ name: '新质生产力', width: '94px' },
			// 	{ name: '体制改革', width: '80px' },
			// 	{ name: '数字经济', width: '66px' },
			// 	{ name: '智慧城市', width: '94px' },
			// 	{ name: '法治中国', width: '80px%' },
			// 	//协调
			// 	{ name: '区域协同发展', width: '110px' },
			// 	{ name: '西部大开发', width: '138px' },
			// 	{ name: '长三角一体化', width: '138px' },
			// 	{ name: '东北全面振兴', width: '94px' },
			// 	{ name: '中部地区崛起', width: '110px' },
			// 	{ name: '东部地区率先发展', width: '120px' },

			// 	{ name: '京津冀协同发展', width: '110px' },
			// 	{ name: '长江经济带', width: '110px' },
			// 	{ name: '黄河流域高质量发展', width: '138px' },
			// 	{ name: '粤港澳大湾区', width: '94px' },
			// 	{ name: '成渝双城经济圈', width: '110px' },
			// 	{ name: '国家级新区', width: '100%' },
			// 	{ name: '新型城镇化', width: '94px' },
			// 	{ name: '乡村振兴', width: '110px' },
			// 	//绿色
			// 	{ name: '生态文明', width: '66px' },
			// 	{ name: '资源环境', width: '66px' },
			// 	{ name: '绿色发展', width: '66px' },
			// 	{ name: '低碳经济', width: '66px' },
			// 	{ name: '新能源产业', width: '100%' },
			// 	//开放
			// 	{ name: '对外开放', width: '100%' },
			// 	{ name: '跨国投资', width: '100%' },
			// 	{ name: '国际贸易', width: '100%' },
			// 	//共享
			// 	{ name: '共同富裕', width: '66px' },
			// 	{ name: '人口与发展', width: '100%' },
			// 	{ name: '社会保障', width: '66px' },
			// 	{ name: '国情民生', width: '66px' },
			// 	{ name: '优秀传统文化', width: '94px' },
			// 	{ name: '中华民族共同体', width: '100%' },
			// ],
			upListWidth: [
				//创新
				{ name: '中国式现代化', width: '94px' },
				{ name: '高质量发展', width: '80px' },
				{ name: '创新驱动', width: '66px' },
				{ name: '新质生产力', width: '79px' },
				// { name: '体制改革', width: '80px' },
				{ name: '数字经济', width: '66px' },
				// { name: '智慧城市', width: '94px' },
				// { name: '法治中国', width: '80px%' },
				//协调
				{ name: '区域协同发展', width: '95px' },
				// { name: '西部大开发', width: '138px' },
				// { name: '长三角一体化', width: '138px' },
				// { name: '东北全面振兴', width: '94px' },
				// { name: '中部地区崛起', width: '110px' },
				// { name: '东部地区率先发展', width: '120px' },

				// { name: '京津冀协同发展', width: '110px' },
				// { name: '长江经济带', width: '110px' },
				// { name: '黄河流域高质量发展', width: '138px' },
				{ name: '粤港澳大湾区', width: '94px' },
				{ name: '海洋经济', width: '63px' },
				// { name: '成渝双城经济圈', width: '110px' },
				// { name: '国家级新区', width: '100%' },
				// { name: '新型城镇化', width: '94px' },
				// { name: '乡村振兴', width: '110px' },
				//绿色
				{ name: '生态文明', width: '66px' },
				// { name: '资源环境', width: '66px' },
				{ name: '绿色发展', width: '66px' },
				// { name: '低碳经济', width: '66px' },
				{ name: '新能源产业', width: '100%' },
				//开放
				{ name: '对外开放', width: '100%' },
				// { name: '跨国投资', width: '100%' },
				// { name: '国际贸易', width: '100%' },
				//共享
				{ name: '共同富裕', width: '66px' },
				// { name: '人口与发展', width: '100%' },
				// { name: '社会保障', width: '66px' },
				// { name: '国情民生', width: '66px' },
				{ name: '优秀传统文化', width: '86px' },
				{ name: '中华民族共同体', width: '106px' },
			],
		};
	},
	computed: {},
	watch: {},
	mounted() {
		// this.getNavs();
	},
	methods: {
		gotoLink(item) {
			this.$eventBus.$emit('upLists', item.uid);
		},
		//导航上的跳转链接-打开新页跳转的
		getAlink(url, uid, item) {
			var returnUrl = 'javascript:void(0);';
			if (
				this.$route.name != 'specialTopicNoLeft' &&
				item.children.length <= 0 &&
				item.tagIds == null
			) {
				returnUrl = '/custom/specialTopicNoLeft?uid=' + uid;
			}

			if (
				this.$route.name != 'specialTopic' &&
				(item.children.length > 0 || item.tagIds != null)
			) {
				returnUrl = '/custom/specialTopic?uid=' + uid;
			}

			return returnUrl;
		},
		getNavs() {
			getNav({ uid: 'A7', depth: '0' }).then((res) => {
				console.log('res', res);

				let templist = res.data.data;
				for (let index = 0; index < templist.length; index++) {
					const element = templist[index];
					if (element.uid == 'A705') {
						for (let j = 0; j < element.children.length; j++) {
							const data = element.children[j];
							if (data.isnav == true) {
								this.tableData.push(data);
							}
						}
					}
				}
			});
		},
		//设置avtive的颜色
		getcDeepBlueClass(_uid) {
			if (this.$route.query && this.$route.query.uid) {
				if (_uid == this.$route.query.uid) {
					return 'cDeepBlue fontRed';
				}
				return 'cDeepBlue';
			} else {
				return 'cDeepBlue';
			}
		},
		//设置每块的宽度
		itemWidthFunction(text) {
			let itemWidth = this.itemWidth;

			if (itemWidth.findIndex((name) => name.name == text) >= 0) {
				for (let index = 0; index < itemWidth.length; index++) {
					const element = itemWidth[index];
					if (element.name == text) {
						return element.width;
					}
				}
			} else {
				return '100%';
			}
		},
		//设置每个文字框的宽度
		upListWidthFunction(text) {
			let upListWidth = this.upListWidth;

			if (upListWidth.findIndex((name) => name.name == text) >= 0) {
				for (let index = 0; index < upListWidth.length; index++) {
					const element = upListWidth[index];
					if (element.name == text) {
						return element.width;
					}
				}
			} else {
				return '100%';
			}
		},
	},
};
</script>
<style lang="less" scoped>
.upList {
	background: transparent;
	// border: 1px solid #aecff5;
	padding: 11px 0;
	// height: 112px;
	height: 50px;
}

.upList {
	// background: rgb(240, 248, 255);
	display: flex;
	width: 1300px;

	// border: 1px solid #aecff5;
	.list-item {
		// display: grid;
		// grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
		display: block;
		// flex-flow: row wrap;
		// writing-mode: horizontal-tb !important;
		// writing-mode: vertical-lr !important;
		border-right: 1px solid #dddee0;
		padding-left: 8px;

		// margin-right: 8.5px;
		// padding-right: 3.5px;
		// justify-content: center;
		.item {
			align-items: center;
			// margin-bottom: 6px;
			// writing-mode: vertical-lr !important;
			// writing-mode: horizontal-tb !important;
			display: inline-block;
			height: 26px;

			// border-right: 1.5px solid #174683;
			// padding: 0 10px 0 26px;
			// padding-right: 12px; /* 调整右边框线的间距 */
			.cDeepBlue {
				text-align: left;
				display: block;
				width: 100%;
				cursor: pointer;
				font-size: 14px;
				color: #333333;
				font-family: 'Microsoft YaHei', '微软雅黑', 'Microsoft JhengHei',
					'华文细黑', STHeiti, MingLiu;
				line-height: 26px;
				/* 添加右边框线 */
			}

			.fontRed {
				color: #c30000;
				font-weight: 600;
			}

			/* 最后一列元素去除右边框线 */
		}
	}

	.list-item:last-child {
		border-right: none;
	}

	.list-item:first-child {
		padding-left: 0;
	}
}
</style>
